__turbopack_context__.v({
  "actions": "WishlistItem-module__YafOSW__actions",
  "addedDate": "WishlistItem-module__YafOSW__addedDate",
  "btn": "WishlistItem-module__YafOSW__btn",
  "btnPrimary": "WishlistItem-module__YafOSW__btnPrimary",
  "btnSecondary": "WishlistItem-module__YafOSW__btnSecondary",
  "card": "WishlistItem-module__YafOSW__card",
  "content": "WishlistItem-module__YafOSW__content",
  "crtOverlay": "WishlistItem-module__YafOSW__crtOverlay",
  "description": "WishlistItem-module__YafOSW__description",
  "dot": "WishlistItem-module__YafOSW__dot",
  "dotActive": "WishlistItem-module__YafOSW__dotActive",
  "galleryBtn": "WishlistItem-module__YafOSW__galleryBtn",
  "galleryCounter": "WishlistItem-module__YafOSW__galleryCounter",
  "galleryOverlay": "WishlistItem-module__YafOSW__galleryOverlay",
  "headerRow": "WishlistItem-module__YafOSW__headerRow",
  "image": "WishlistItem-module__YafOSW__image",
  "imageArea": "WishlistItem-module__YafOSW__imageArea",
  "imagePlaceholder": "WishlistItem-module__YafOSW__imagePlaceholder",
  "linksGroup": "WishlistItem-module__YafOSW__linksGroup",
  "metaRow": "WishlistItem-module__YafOSW__metaRow",
  "metaTag": "WishlistItem-module__YafOSW__metaTag",
  "noteBox": "WishlistItem-module__YafOSW__noteBox",
  "noteLabel": "WishlistItem-module__YafOSW__noteLabel",
  "price": "WishlistItem-module__YafOSW__price",
  "tag": "WishlistItem-module__YafOSW__tag",
  "tagsGroup": "WishlistItem-module__YafOSW__tagsGroup",
  "title": "WishlistItem-module__YafOSW__title",
});
